import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ApptContext } from "../../../store";

// Update log
//

export default function AdminDashboard() {
  const matches = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const { state, dispatch } = useContext(ApptContext);
  let adminName = "Admin";
  // const matches = useMediaQuery("(min-width:200px)");
  const stylestop = {
    container: {
      border: "1px grey",
      backgroundColor: "white",
      padding: matches == false ? "32px 10px" : "32px 40px",
      height: "auto",
    },
  };
  let userName: any;
  let data = sessionStorage.getItem("user");

  if (data != null) {
    adminName = JSON.parse(data).AdminFirstName;
    userName = JSON.parse(data).Login;
  }
  // async function InsertLogs() {
  //   InsertPPLogs("Viewing Dashboard", window.location.href, userName, "");
  // }

  const handleFindPatient = () => {
    state.AppointmentType = "";
    navigate("/admin/find_patient");
  };

  // useEffect(() => {
  //   InsertLogs();
  // }, []);

  return (
    <div>
      <div className="card" style={stylestart.container}>
        <label
          style={
            matches == false
              ? {
                textAlign: "left",
                color: "black",
                backgroundColor: "#F5F5F5",
                paddingLeft: "16px",
                fontSize: "32px",
                fontWeight: "700",
                lineHeight: "40px",
              }
              : {
                textAlign: "left",
                color: "black",
                backgroundColor: "#F5F5F5",
                paddingLeft: "80px",
                paddingTop: "20px",
                fontSize: "32px",
                fontWeight: "700",
                lineHeight: "40px",
              }
          }
        >
          {"Welcome, " + adminName}
        </label>

        <div className="card " style={stylesbegin.container}>
          <div
            className="row"
            style={
              matches == false
                ? stylestopmobile.container
                : { padding: "32px 80px", backgroundColor: "#F5F5F5" }
            }
          >
            <div className="col-sm-6">
              <div
                className="card"
                style={
                  matches == false
                    ? {
                      border: "1px grey",
                      backgroundColor: "white",
                      padding: "32px 10px",
                      height: "auto",
                      marginBottom: "16px",
                    }
                    : stylestop.container
                }
              >
                <div className="card-body-name">
                  <span
                    className="card-title"
                    style={{
                      fontFamily: "Inter",
                      fontSize: "24px",
                      fontWeight: 700,
                      lineHeight: "32px",
                      letterSpacing: "0em",
                      paddingTop: "64.5px",
                    }}
                  >
                    Find Patients
                  </span>

                  <br></br>
                  <label
                    className="card-text"
                    style={{
                      fontFamily: "Inter",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "24px",
                      letterSpacing: "0em",
                      textAlign: "left",
                      paddingBottom: "16px",
                      paddingTop: "16px",
                    }}
                  >
                    To view patient's account click here,
                  </label>
                  <br></br>
                  <button
                    className="btn"
                    style={button.container}
                    onClick={handleFindPatient}
                  >
                    Find Patient
                  </button>
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="card" style={stylestop.container}>
                <div className="card-body-name">
                  <span
                    className="card-title"
                    style={{
                      fontFamily: "Inter",
                      fontSize: "24px",
                      fontWeight: 700,
                      lineHeight: "32px",
                      letterSpacing: "0em",
                      paddingTop: "64.5px",
                    }}
                  >
                    Practice Header
                  </span>
                  <br></br>
                  <label
                    className="card-text"
                    style={{
                      fontFamily: "Inter",
                      fontSize: "16px",
                      fontWeight: 400,
                      lineHeight: "24px",
                      letterSpacing: "0em",
                      textAlign: "left",
                      paddingBottom: "16px",
                      paddingTop: "16px",
                    }}
                  >
                    To change the Practice header click here,
                  </label>
                  <br></br>
                  <button
                    className="btn"
                    style={button.container}
                    onClick={() => navigate("/admin/update_logo")}
                  >
                    Change Practice Header
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const stylestart = {
  container: {
    border: "1px grey",
    backgroundColor: "#F5F5F5",
    marginBottom: "20px",
  },
};
const stylesbegin = {
  container: {
    border: "1px grey",
    backgroundColor: "#F5F5F5",
  },
};

const stylestopmobile = {
  container: {
    padding: "32px 16px 16px 16px",
    backgroundColor: "#F5F5F5",
  },
};

const stylestoptwo = {
  container: {
    border: "1px grey",
    backgroundColor: "white",
    padding: "32px 40px",
  },
};
const button = {
  container: {
    backgroundColor: "#13607C",
    color: "white",
  },
};
